import { GetInventoryPriceStatusesReq } from '@/services/inventory/inventoryPriceStatus/types'
import { FIELD_NAMES } from './constants'

export interface InventoryPriceStatusFormValues {
  [FIELD_NAMES.shipperCode]?: string
  /** 브랜드명 다중 선택. '전체'는 빈 문자열이라 아래에서 자연히 걸러진다. */
  [FIELD_NAMES.brandName]?: string[]
  [FIELD_NAMES.goodsCode]?: string
  [FIELD_NAMES.barcodes]?: string[]
}

/**
 * 필터 폼 값 → 조회 요청 변환.
 *
 * 1.0 ST07 은 컨테이너 handleSearch 가 치환 없이 그대로 전달했다(핸드오프 §조회 노트 — ST02 의 ALL→'' 같은
 * 가공 없음). 여기서도 trim 과 빈 값 제거만 한다 — 빈 문자열이 EQUAL 필터로 가면 무결과가 된다.
 * 클라이언트 필수 검증도 없다(1.0 실측) — 무필터 400 은 화주명 기본값(세션 화주)이 항상 차 있어 도달하지 않는다.
 */
export const toInventoryPriceStatusesReq = (values: InventoryPriceStatusFormValues): GetInventoryPriceStatusesReq => {
  const sprNm = values[FIELD_NAMES.shipperCode]?.trim()
  // 다중 선택 브랜드는 1.0 STC_BRD_NM 계열 파라미터로 보낸다(ST02 동일 — mi.brand IN).
  const stcBrdNm = (values[FIELD_NAMES.brandName] ?? []).map((v) => v.trim()).filter(Boolean)
  const gdsCd = values[FIELD_NAMES.goodsCode]?.trim()
  const barcode = (values[FIELD_NAMES.barcodes] ?? []).map((v) => v.trim()).filter(Boolean)

  return {
    ...(sprNm ? { sprNm } : {}),
    // '전체'(빈 문자열)만 선택된 상태면 브랜드 키를 싣지 않는다 = 전 브랜드 조회.
    ...(stcBrdNm.length > 0 ? { stcBrdNm } : {}),
    ...(gdsCd ? { gdsCd } : {}),
    ...(barcode.length > 0 ? { barcode } : {}),
  }
}
